import { observer } from 'mobx-react-lite'
import React, { useEffect, useState } from 'react'
import SearchMultiselect from '../components/SearchMultiselect'
import { Container } from '../components/Animations'
import Radom from '../state/Radom'
import Treasury from '../state/Treasury'
import User from '../state/User'
import { Currencies, Currency } from '../util/Currencies'
import { errorToast, successToast } from '../util/Util'
import {
  SettingsCard,
  SettingsCardBody,
  SettingsHero,
  SettingsPage,
  SettingsRow,
  SettingsRowDescription,
  SettingsRows,
  SettingsRowTitle,
  SettingsSubtext,
  SettingsTitle,
  StatusPill
} from './Organization/SettingsLayout'

const CurrencySettings = observer((): React.ReactElement => {
  const [currencyLoading, setCurrencyLoading] = useState(true)
  const [currency, setCurrency] = useState<Currency>()

  useEffect(() => {
    if (User._user?.defaultOrganizationId) {
      setCurrencyLoading(true)
      Radom.getOrganizationById(User._user.defaultOrganizationId)
        .then(r => {
          setCurrency(Currencies.filter(c => c.ticker === r.defaultCurrency)[0])
        })
        .catch(err => console.error('Failed to load currency', err))
        .finally(() => setCurrencyLoading(false))
    } else {
      setCurrencyLoading(false)
    }
  }, [User._user?.defaultOrganizationId])

  return (
    <Container>
      <SettingsPage>

        <SettingsHero>
          <div>
            <SettingsTitle>Currency</SettingsTitle>
            <SettingsSubtext>
              Set the default currency used across dashboard summaries and reporting.
            </SettingsSubtext>
          </div>
          <StatusPill $tone={currency ? 'green' : 'neutral'}>
            {currency?.ticker ?? 'No currency set'}
          </StatusPill>
        </SettingsHero>

        <SettingsCard>
          <SettingsCardBody>
            <SettingsRows>
              <SettingsRow>
                <div>
                  <SettingsRowTitle>Default currency</SettingsRowTitle>
                  <SettingsRowDescription>
                    Used across dashboard summaries, balances, and hosted payment previews.
                  </SettingsRowDescription>
                </div>
                <div style={{ minWidth: 260 }}>
                  <SearchMultiselect
                    isLoading={currencyLoading}
                    disabled={false}
                    placeholder="Select currency"
                    itemArray={Currencies}
                    selectedItems={currency ? [currency] : []}
                    setSelectedItems={async c => {
                      if (!c[0]) return
                      try {
                        await Radom.updateSellerProfile({ defaultCurrency: c[0].ticker })
                        await User.getOrganization(true)
                        Treasury.loadPriceQuotes(true)
                        successToast('Updated default currency')
                        setCurrency(c[0])
                      } catch (err: any) {
                        errorToast(err.response?.data?.error || err.message)
                      }
                    }}
                    keyExtractor={c => c.ticker}
                    labelExtractor={c =>
                      <div style={{ display: 'flex', gap: 5, alignItems: 'center' }}>{c.icon}{c.ticker}</div>}
                    isSingleSelect
                  />
                </div>
              </SettingsRow>
            </SettingsRows>
          </SettingsCardBody>
        </SettingsCard>

      </SettingsPage>
    </Container>
  )
})

export default CurrencySettings
